var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.dialog
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" Confirm your action ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12"
                    }
                  },
                  [_c("p", [_vm._v(_vm._s(_vm.text))])]
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: ""
                },
                on: {
                  click: _vm.confirm
                }
              },
              [_vm._v("Confirm")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }